<template>
  <Teleport to="#app">
    <input type="checkbox" id="product-modal" class="modal-toggle" />
    <label class="modal" for="product-modal">
      <label class="modal-box max-w-5xl" for="">
        <div class="grid md:grid-cols-2 gap-4 modal-content">
          <div>
            <h3 class="font-bold text-lg text-gray-custom-1">
              {{ product.title }}
            </h3>
            <label class="btn btn-ghost btn-block mt-3 bg-purple-custom-1 !text-purple-custom-2 justify-start"
              for="video-modal" v-if="product?.introduction_link">
              <VideoCameraIcon class="w-5 h-5 ml-2" />
              {{ __('See the video description of this product') }}
            </label>
            <label class="btn btn-ghost btn-block mt-3 justify-start bg-orange-custom-1 !text-orange-custom-2"
              for="description-modal" @click="introductionBrand = product.introduction_brand" v-if="product.introduction_brand">
              <ComputerDesktopIcon class="w-5 h-5 ml-2" />
              {{ __('Get to know more about the brand of the product manufacturer') }}
            </label>
            <div class="card mt-3 border">
              <div class="card-body gap-0 p-0 rounded-sm">
                <div class="grid grid-cols-2 bg-gray-custom-6 p-3">
                  <p class="text-gray-custom-1">{{ __('brand') }}</p>
                  <p class="text-gray-custom-1">{{ product.brand || '---' }}</p>
                </div>
                <div class="divider my-0 h-auto"></div>
                <div class="grid grid-cols-2 p-3" v-if="product.payment_method">
                  <p class="text-gray-custom-1">{{ __('Selling Type') }}</p>
                  <span class="badge border-0 rounded-sm text-sm"
                :class="[product.payment_method === 'cash' ? '!bg-red-custom-1 !text-red-custom-2' : ' !bg-green-custom-2 !text-green-custom-3']">{{__(product.payment_method?.capitalize()) + (product.payment_method == 'check' && product.payment_term ? ' - ' + product.payment_term + ' ' + __('Day') : '')}}</span>
                </div>
                <div class="divider my-0 h-auto"></div>
                <div class="grid grid-cols-2 bg-gray-custom-6 p-3">
                  <p class="text-gray-custom-1">{{ __('sales price') }}</p>
                  <p class="text-red-custom-2 flex flex-col" v-if="product.wholesale_price">
                    <span>{{ product.wholesale_price?.toLocaleString() }} <Currency /></span>
                     <span class="text-gray-custom-1 text-sm line-through" v-if="product.regular_price > product.wholesale_price">{{ product.regular_price.toLocaleString() }}</span>
                  </p>
                  <p class="text-info flex flex-col" v-else>{{ __(product.stock_status?.replace('_',' ')?.capitalize()) }}</p>
                </div>
                <div class="divider my-0 h-auto" v-if="product.package_type"></div>
                <div class="grid grid-cols-2 p-3" v-if="product.package_type">
                  <p class="text-gray-custom-1">{{ __('Package Type') }}</p>
                  <p class="text-gray-custom-1">{{ product.package_type }}</p>
                </div>
                <div class="divider my-0 h-auto" v-if="product.suitable_for"></div>
                <div class="grid grid-cols-2 p-3" :class="{'bg-gray-custom-6': product.package_type}" v-if="product.suitable_for">
                  <p class="text-gray-custom-1">{{ __('Suitable for') }}</p>
                  <p v-html="product.suitable_for" class="text-gray-custom-1"></p>
                </div>
              </div>
            </div>
            <label class="btn btn-error btn-block mt-3 hidden md:flex" for="product-modal">{{ __('Close') }}</label>
          </div>
          <div class="order-first md:order-last">
            <img class="w-full rounded" alt="image"
              :src="activeImage || (product?.gallery?.length ? product.gallery[0] : null)">
            <div class="grid gap-2 grid-cols-3 lg:grid-cols-4">
              <img class="w-24 h-24 sm:w-28 sm:h-28 rounded mt-3 cursor-pointer" v-for="image in product.gallery"
                alt="image" :src="image" @click="activeImage = image">
            </div>
          </div>
        </div>
        <div class="modal-action items-center md:hidden">
          <label class="btn btn-error btn-sm" for="product-modal">{{ __('Close') }}</label>
        </div>
      </label>
    </label>
    <input type="checkbox" id="video-modal" class="modal-toggle" />
    <div class="modal video-modal">
      <div class="modal-box max-w-3xl" v-if="product?.introduction_link">
        <div class="w-full relative" v-if="product?.introduction_link?.includes('.mp4')">
          <video ref="productVideo">
            <source :src="`${product?.introduction_link}#t=0.${new Date().getTime()}`" type="video/mp4">
            Your browser does not support the video tag.
          </video>
          <div class="romeo-embed-inner" @click="playVideo($event)"><span class="romeo-embed-play"><svg viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg" width="18" height="18">
                <path
                  d="M7 6.134v11.732c0 .895 1.03 1.438 1.822.951l9.628-5.866c.733-.441.733-1.46 0-1.914L8.822 5.183C8.029 4.696 7 5.239 7 6.134z"
                  fill="#FBFBFC"></path>
              </svg></span></div>
        </div>
        <div v-html="product?.introduction_link" v-else></div>
        <div class="modal-action">
          <label class="btn btn-primary btn-sm" for="video-modal" @click="stopVideo">{{ __('Close') }}</label>
        </div>
      </div>
    </div>
    <input type="checkbox" id="description-modal" class="modal-toggle" />
    <div class="modal">
      <div class="modal-box max-w-2xl">
        <div v-html="introductionBrand" class="modal-content mce-content-body"></div>
        <div class="modal-action">
          <label class="btn btn-error btn-sm" for="description-modal" @click="introductionBrand = null">{{ __('Close') }}</label>
        </div>
      </div>
    </div>
  </Teleport>
</template>
<script setup>
import {
  VideoCameraIcon,
  ComputerDesktopIcon,
} from '@heroicons/vue/24/outline'
import { ref,watch } from 'vue';
import Currency from '../../svg/Currency.vue';
defineEmits(['productModal']);
const props = defineProps(['product', 'show']);
const activeImage = ref(null);
const productVideo = ref(null);
const introductionBrand = ref(null);
const playVideo = () => {;
  document.querySelector('.video-modal .romeo-embed-inner')?.classList?.add('hidden');
  productVideo.value.play();
  productVideo.value.setAttribute('controls', 'controls');
}
const stopVideo = () => {
  document.querySelector('.video-modal .romeo-embed-inner')?.classList?.remove('hidden');
  productVideo.value.pause();
  productVideo.value.currentTime = 0;
  productVideo.value.removeAttribute('controls');
}
watch(props.product,() => {
  activeImage.value = null;
  productVideo.value?.load();
});
</script>